import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { defaultLang } from 'app/utils/lang';
import langFA from './languages/fa';
import langEN from './languages/en';
import langAR from './languages/ar';
import langTJ from './languages/tj';

i18n
  .use(initReactI18next)
  .init({
    debug: false,
    fallbackLng: (window.location.pathname).split('/')[1] || localStorage.getItem('lang') || defaultLang(),
    interpolation: {
      escapeValue: false,
    },
    resources: {
      en: langEN,
      fa: langFA,
      ar: langAR,
      tj: langTJ,
    },
  });

export default i18n;
